/* Amend Columns for Filters Oct 23, 2022 */
/* Add store and use pageSize, skipLoad=false fn_byOpprTypeHandler May 27, 2023 */
/* Add fn_addCustomFields Aug 5, 2023 */
/* Amend status buttons filter  Oct 7, 2023 */
/* Amend to fix Glitch add offset, limit to opportunitiesGrouped Oct 11, 2023 */
/* Add fn_setFilters() to fn_byOpprTypeHandler button statuses  Oct 21, 2023 */
/* Add http to url if not present Nov 18, 2023 */
/* Add sortable=true for customFields July 31, 2024 */
/* Move all quick filters to Font End Dec 7, 2024 */
/* Add multiSelect to CustomData fields Dec 21, 2024 */
/* Add additionalcolumns for read Only Columns  Jan 25, 2025 */
/* Add title to some columns and psqft  Sep 6, 2025 */
/* Add datatype to all columns,datatype:array to array columns like competitors Oct 25, 2025 */
/* Add reportWidth, notes  Apr 30, 2026 */
<template lang="pug">
	div(class="oppr-nav")
		div(class="nav-header")
			div
				b-button(v-for="t in d_tabs" :key="t.ix" variant="none" :pressed="d_tabCurr.ix==t.ix" @click="m_tabClick(t)") {{t.lbl}}
			
			slot(name="team-member-filter" :fCU="d_tabCurr.ix>1" :fTM="d_tabCurr.ix!=1")
		div
			b-card(v-for="tabTbl in d_tabCurr.tabTbls||[d_tabCurr]" :key="tabTbl.ix" style="border:none;margin:0;")
				b-card-header
					span(v-if="tabTbl.otNm") {{tabTbl.otNm}}
					b-button-group
						span(v-for="(fb, ix) in tabTbl.filterBtns" :key="ix" 
							class="btn btn-outline-secondary"
							:class="fb.state?'btn-active':null"
							:title="tabTbl.fn_fbTitle(fb)"
							@click="tabTbl.fn_fbClick(fb)"
							) {{fb.osNm||fb.label}}
						span(v-if="tabTbl.fn_tglAll" class="btn btn-link" title="Select All" @click="tabTbl.fn_tglAll(true)") All
						span(v-if="tabTbl.fn_tglAll" class="btn btn-link" title="Clear All" @click="tabTbl.fn_tglAll(false)") Clear
				b-card-body(style="padding:0")
					kt-table(v-if="d_tabCurr.ix == 2"
								p_appEntKey="oppr" 
								:ref="'kt-table' + c_tblIdKey"
								:p_tblIdKey="c_tblIdKey"
								:p_opts="c_ktOptions"
								:p_cols="c_ktColumns"
								:p_qryPrms="tabTbl.qryPrms" 
								:p_tbNote="tabTbl.tbNote"
								:p_tbInfo="tabTbl.fn_tbInfo()"
								:p_skipLoad="tabTbl.skipLoad||null"
								:p_data="d_data||[]"
								)
			b-card-body(style="padding:0")
				kt-table(v-if="d_tabCurr.ix != 2"
						p_appEntKey="oppr" 
						:ref="'kt-table'+c_tblIdKey"
						:p_tblIdKey="c_tblIdKey"
						:p_opts="c_ktOptions"
						:p_cols="c_ktColumns"
						:p_qryPrms="c_qryPrms" 
						:p_tbNote="c_tbNote"
						:p_tbInfo="c_tbInfo"
						:p_skipLoad="c_skipLoad||null"
						:p_data="d_data||[]"
						)
</template>


<script>
import KTTable from "@/components/Ctrl/KT-Table.vue";
import util, {fn_footerFmtr_value} from "@/utils/util.js";
import {fn_getTableData} from "@/utils/api.js";
import {refData,userInfo,userSettings} from "@/utils/ref-data.js";
export default {
	name: "oppr-nav",
	components: {
		"kt-table": KTTable,
	},
	created() {
		//Kepp Order
		
		
		
				
		var d_qryPrms=null;
		//var today=new Date(); 
		this.d_tabs = fn_getTabs(this);
		//this.d_ktColumns=fn_getColumns();
		//this.d_tabCurr = this.c_cuFilter ? this.d_tabs[1] : this.d_tabs[0];
		
	
		console.log('window.location.href-quickFilter');
		console.log(window.localStorage.getItem(window.location.href+'-quickFilter'));
		
	
		
		
		if(window.localStorage.getItem(window.location.href+'-quickFilter1')) {
			try{
				
				d_qryPrms=JSON.parse(window.localStorage.getItem(window.location.href+'-quickFilter'));
				console.log(d_qryPrms);
				} catch(err){d_qryPrms=null;}
				
		
		
	
		if(d_qryPrms) {
			console.log('In OpprNav d_qryPrms');
			d_qryPrms['withArchived']=false;
			if(d_qryPrms.ix==3&&d_qryPrms.days) { 
							var dueDate=new Date();
							d_qryPrms.dueDate=util.fn_isoDtStr(dueDate.setDate(dueDate.getDate()+d_qryPrms.days));
							}
							
			this.d_tabs[d_qryPrms.ix].qryPrms=d_qryPrms;
			this.d_tabCurr = this.d_tabs[d_qryPrms.ix];
			
			
			
			if(d_qryPrms.opportunityStatusIds) 
				this.d_tabCurr.filterBtns.forEach(b=>{b.state=d_qryPrms.opportunityStatusIds.includes(b.osId)&&b.osNm != 'Archived';});
		
			if(d_qryPrms.ix==3) this.d_tabCurr.filterBtns.forEach(b=>{b.state=b.days==d_qryPrms.days;});
				
		
			} 
		
		} else this.d_tabCurr = this.c_cuFilter ? this.d_tabs[1] : this.d_tabs[0];
		
		
		
		
	},
	mounted(){
	if(window.localStorage.getItem(window.location.href+'-pageSize'))
	this.d_pageSize=parseInt(window.localStorage.getItem(window.location.href+'-pageSize'));
	//this.d_ktColumns=fn_getColumns();
	},
	data() {
		return {
			d_tabs: [],
			d_tabCurr: {},
			d_pageSize:parseInt(window.localStorage.getItem(window.location.href+'-pageSize'))||25,
			d_ktColumns: [],
			d_data:[],
			d_qryPrms:{},
			d_teamMemberId: userInfo.getUserInfo().teamMember.teamMemberId,
			d_withArchived:false,
		};
	},
	computed: {
		c_ktOptions() {
			let ti = this.d_tabCurr.ix;
			return {
				pageSize: this.d_pageSize,
				maxHeight: ti == 2 ? 360 : null,
			};
		},
		c_ktColumns() {
			let cols = fn_getColumns();
			//cols.filter(x => x.field == 'opportunityTypeId')[0].default = this.d_tabCurr.ix != 2;
			console.log('OpprNav columns');
			console.log(cols);
			return cols;
		},
		c_cuFilter() {
			return this.$parent.d_cuFilter;
		},
		c_tmIdFilter() {
			return (this.$parent.d_tmFilter || {}).teamMemberId || null;
		},
		c_tblIdKey(){return this.d_tabCurr.tblIdKey;},
		c_qryPrms(){return this.d_tabCurr.qryPrms;},
		c_tbNote(){return this.d_tabCurr.tbNote;},
		c_tbInfo(){return this.d_tabCurr.fn_tbInfo();},
		c_skipLoad(){return this.d_tabCurr.skipLoad;},
	},
	methods: {
	m_tabClick(t){
			t.withArchived=false;
			t.filterBtns||[].filter(b=>b.osNm == 'Archived').forEach(x =>{ x.state = false;});
			this.d_tabCurr=t;
			window.localStorage.setItem(window.location.href+'-quickFilter',JSON.stringify(this.d_tabCurr.qryPrms));
				}
	},
	watch: {
		d_tabCurr(nv, ov) {
			if (nv.ix == 1) this.$parent.d_cuFilter = true;
			else if (ov.ix == 1 || nv == 0) this.$parent.d_cuFilter = null;

			if (ov.ix >= 0 && nv.ix != 2) fn_setTabProps(nv, this);

			else if (nv.ix == 2) fn_byOpprTypeHandler(this);
			else if (ov.ix == 2) this.d_tabs[2].tabTbls.forEach(x => x.skipLoad = false);
		
			window.localStorage.setItem(window.location.href+'-quickFilter',JSON.stringify(nv.qryPrms));
		
			console.log('In OpprNav watch');
			console.log(this.d_tabCurr);
		},
		'$parent.c_cutmKey'(nv, ov) {
			let ct = this.d_tabCurr;
			if (ct.ix == 0 && ov != -1) fn_setTabProps(ct, this);

			else if (ct.ix == 3) fn_setTabProps(ct, this);
			else if (ct.ix == 2) fn_byOpprTypeHandler(this);
		},
	}
};
export {fn_getColumns};

function fn_getColumns() {
	var columns= [
		{
			field: "opportunityNo",
			title: "Opportunity#",
			_numKey: true,
			openOnClick: true,
			default: true,
			datatype:"text",
			sortable:true,
			__dbvw: true,
		},
		{
			field: "opportunityName",
			title: "Opportunity Name",
			openOnClick: true,
			default: true,
			sortable:true,
			datatype:"text",
			__dbvw: true,
			reportWidth:500
		},
		{
			field: "opportunityTypeId",
			title: "Opportunity Stage",
			_refData: refData.opportunityTypes,
			sortable:true,
			__dbvw: true,

		},
                {
			field: "categoryId",
			title: "Category",
			_refData: refData.categories,
			sortable:true,
			__dbvw: true,

		},
		{
			field: "contractTypeId",
			title: "Contract Type",
			_refData: refData.contractTypes,
			default: true,
			sortable:true,
		},
		{
			field: "clientAccountId",
			title: "Client",
			_refId: "accountId",
			_refName: "accountName",
			default: true,
			sortable:true,
			__dbvw: true,
			reportWidth:500
		},
		{
			field: "value",
			title: "Value",
			default: true,
			footerFormatter: fn_footerFmtr_value,
			valFmtFn: val => util.fn_fmtMoney(val),
			showAggr: 'sum',
			aggrTitle:'Total Value:',
			datatype: 'num',
			sortable:true,
			__dbvw: true,
		},
		{
			field: "projectSize",
			title: "Project Size",
			default: true,
			valFmtFn: val => util.fn_fmtSf(val),
			datatype: 'num',
			sortable:true,
			__dbvw: true,
		},
                {
			field: "psqft",
            title: "Value per sq ft",
			sortable:false,
			default: true,
			datatype: 'num',
		},
		{
			field: "dueDate",
			title:"Due Date",
			default: true,
			datatype:"date",
			sortable:true,
		},
		{
			field: "opportunityStatusId",
			title: "Status",
			_refData: refData.opportunityStatuses,
			default: true,
			sortable:true,
			__dbvw: true,
			datatype:"text",
		},
		{
			field: "opportunitySubStatusId",
			title: "Sub Status",
			_refData: refData.opportunitySubStatuses,
			_refName: "opportunitySubStatusName",
			sortable:true,
			datatype:"text",
			
		},
		{
			field: "projectNo",
			titel: "Project No",
			linkFn: (col, row, vc) => {
				return {path: util.fn_hrefVwRec('proj', row['projectNo'])};
			},
			datatype:"text",
		},
		{
			field: "projectName",
			title:"Project Name",
			linkFn: (col, row, vc) => {
				return {path: util.fn_hrefVwRec('proj', row['projectNo'])};
			},
			sortable:true,
			datatype:"text",
			reportWidth:500
		},
		{
			field: "marketSegmentId",
			title: "Market Segment",
			_refData: refData.marketSegments,
			sortable:true,
			datatype:"text",
		},
		{
			field: "leadSourceId",
			title: "Lead Source",
			_refData: refData.leadSources,
			sortable:true,
			datatype:"text",
		},
		{
			field: "internalContactId",
			_refId: "teamMemberId",
			_refName: "teamMemberName",
			__dbvw: true,
			sortable:true,
			datatype:"num",
		},
		{
			field: "primaryClientAccountContactId",
			title: "Primary Client Contact",
			_refId: "externalContactId",
			_refName: "externalContactName",
			sortable:true,
			datatype:"text",
		},
		{field: "streetAddress",
		title: "Street Address",
		datatype:"text",
		sortable:true,
		reportWidth:500},
		{field: "city",title: "City",datatype:"text",sortable:true},
		{
			field: "stateProvince",
			title: "State or Province",
			datatype:"text",
			sortable:true
		},
		{field: "zipCode",
		title: "Zip Code",
		datatype:"text",
		sortable:true},
		{
			field: "winProbability",
			title: "Win Probability",
			_refData: refData.probabilities,
			_refId: "value",
			_refName: "text",
			datatype: 'num',
			sortable:true,
			valFmtFn: (val) => {
				return val?val+'%':null;
			}
		},
		{
			field: "secureProbability",
			title: " Secure Probality",
			_refData: refData.probabilities,
			_refId: "value",
			_refName: "text",
			datatype: 'num',
			sortable:true,
			valFmtFn: (val) => {
				return val?val+'%':null;
			}
		},
		{field: "awardedDate",title:"Awarded Date",datatype:"date",	sortable:true},
		{field: "securedDate",title:"Secured Date",datatype:"date",__dbvw: true,sortable:true},
		{field: "siteWalkThroughDate",datatype:"date",sortable:true},
		{field: "approxConstructionStartDate",sortable:true,datatype:"date"},
		{field: "approxConstructionCompletionDate",datatype:"date",sortable:true},
		{field: "createdById", _refId: "teamMemberId",datatype:"num",},
		{field: "createdUTC", datatype:"date"},
		{field: "updatedById", _refId: "teamMemberId", datatype:"num", },
		{field: "updatedUTC",__dbvw: true,datatype:"date"},
		{field:"designerAccounts", title:"Designer Accounts",datatype:"array"},
		{field:"competitors", title:"Competitors",datatype:"array",},
		{field:"clientAccounts", title:"Additional Clients", datatype:"array"},
		{field:"notes", title:"Notes",htmlFn:val => {return val;}, 
		valFmtFn: val =>{return val?val.replaceAll('<p>','').replaceAll('</p>',''):null;},
		datatype:'multi-line',
		reportWidth:500
		},

	];
	
	var allColumns=[...columns, ...fn_addCustomFields()];
	return allColumns;	
	
}

function fn_getTabs(vc) {
	let tbInfoHelper = (who) => `Opportunities on which ${who} the Internal Contact or an Assigned Team Member`;
	let tabs = [
		{
			ix: 0,
			lbl: 'All',
			tblIdKey: '',
			fn_qryPrms: (tab) => {
				return {
					ix:0,
					days:null,
					opportunityStatusIds: fn_osPrms(tab),
					teamMemberId: vc.c_tmIdFilter,
					currentUser:null,
					dueDate:null,
					dueAfter:null,
					withArchived:vc.d_withArchived,
				};
			},
			fn_tbInfo: () => !vc.c_tmIdFilter ? null : tbInfoHelper('the selected Team Member is'),
		},
		{
			ix: 1,
			lbl: 'My Opportunities',
			tblIdKey: '-currentUser',
			fn_qryPrms: (tab) => {
				return {
					ix:1,
					days:null,
					opportunityStatusIds: fn_osPrms(tab),
					teamMemberId:vc.d_teamMemberId,
					currentUser: true,
					dueDate:null,
					dueAfter:null,
					withArchived:vc.d_withArchived,
				};
			},
			fn_tbInfo: () => tbInfoHelper('you are'),
		}
	];

	tabs.forEach(x => {
		x.filterBtns = refData.opportunityStatuses.map(os => ({
			osNm: os.name,
			osId: os.id,
			state: false
		}));
		x.fn_fbTitle = (fb) => `Filter "${fb.osNm}" Opportunities`;
		x.fn_tglAll = (tgl) => {
			//if(tgl) vc.d_tabCurr.filterBtns.filter(b=>b.osNm !== 'Archived').forEach(x => x.state = tgl);
			if(tgl) vc.d_tabCurr.filterBtns.forEach(b => b.state = b.osNm !== 'Archived');
			else vc.d_tabCurr.filterBtns.forEach(x => x.state = tgl);
			//if (x.qryPrms.opportunityStatusIds) fn_setTabProps(x, vc);
			fn_setTabProps(x, vc);
			fn_saveFilters(vc);
		};
		x.fn_fbClick = (fb) => {
			fb.state = !fb.state;
			if(fb.osNm=='Archived'&&fb.state) vc.d_withArchived=fb.state;
			fn_setTabProps(x, vc);
			window.localStorage.setItem(window.location.href+'-quickFilter',JSON.stringify(vc.d_tabCurr.qryPrms));
			fn_saveFilters(vc);
		};
		fn_setFilters(x);
		fn_setTabProps(x, vc);
	});


	let tabIx2 = {
		ix: 2,
		lbl: 'By Opportunity Stage',
		qryPrms: {ix:2,currentUser:null,days:null,dueDate:null,teamMemberId:null},
		tabTbls: refData.opportunityTypes.map((ot, ix) => {
			let tabTbl = {
				ix: '2-' + ix,
				otNm: ot.name,
				otId: ot.id,
				tblIdKey: '-' + ot.name.toLowerCase(),
				//filterBtns: fn_osByotFilters(ot),
				filterBtns:	refData.opportunityStatuses.map(os => ({
								osNm: os.name,
								osId: os.id,
								state: false
							})),
				fn_fbTitle: (fb) => `Filter ${fb.osNm} ${fb.otNm} Opportunities`,
				qryPrms: null,
				tbNote: null,
				skipLoad: false,
			};
			tabTbl.fn_tglAll = (tgl) => {
			//if(tgl) tabTbl.filterBtns.filter(b=>b.osNm !== 'Archived').forEach(x => x.state = tgl);
			if(tgl) vc.d_tabCurr.filterBtns.forEach(b => b.state = b.osNm !== 'Archived');
			else tabTbl.filterBtns.forEach(x => x.state = tgl);
			//if (tabTbl.qryPrms.opportunityStatusIds) fn_setTabProps(tabTbl, vc);
			fn_setTabProps(tabTbl, vc);
			console.log(vc.d_tabCurr.filterBtns);
			fn_saveFilters(vc);
			};

			tabTbl.fn_fbClick = (fb) => {
				//tabTbl.filterBtns.forEach(x => x.state = x.osId == fb.osId ? !fb.state : false);
				fb.state = !fb.state;
				tabTbl.resp = null;
				tabTbl.qryPrms = tabTbl.fn_qryPrms();
				tabTbl.tbNote = tabTbl.fn_tbNote();
				fn_saveFilters(vc);
				fn_setFilters(tabTbl);
				fn_setTabProps(tabTbl, vc);
				window.localStorage.setItem(window.location.href+'-quickFilter',JSON.stringify(vc.d_tabCurr.qryPrms));
			};

			/*
				Reactivity re-renders all tab tables when filter button state changes...**Not wanted**
				Hence passing static value instead of function to prevent re-rendering all tables when only when one of the tables filter is clicked
				qryParams + tbNote can be null initially. values set via fn_byOpprTypeHandler
			*/

			tabTbl.fn_qryPrms = () => {
				//let fb = tabTbl.filterBtns.filter(x => x.state)[0] || {};

				//let osId = fb.osId || null;
				let tmId = vc.c_tmIdFilter;
				let cu = null;
				if (!tmId) {
					// let tbl = (vc.$refs['kt-table' + tabTbl.tblIdKey] || [])[0];//N/A for initial entry into tab
					cu = vc.c_cuFilter;
				}

				return {
					ix:2,
					days:null,
					opportunityTypeId: ot.id,
					//opportunityStatusId: osId,
					opportunityStatusIds: fn_osPrms(tabTbl),
					teamMemberId: tmId,
					currentUser: cu,
					withArchived:vc.d_withArchived,
				};
			};
			tabTbl.fn_tbNote = () => {
				let tmfLbl = vc.$parent.c_tmFilterLbl;
				let note = (tmfLbl ? tmfLbl.slice(0, -13) : '') + tabTbl.otNm + ' Opportunities ';
				let osNms = tabTbl.filterBtns.filter(x => x.state).map(x => x.osNm);
				let len = osNms.length;
				//if (len==0||len==tabTbl.filterBtns.length) return note + "in all Statuses";
				if (len==0) return note + "in all Statuses";
				else return note + ` in the "${osNms.join('", "')}" Status${(len > 1 ? 'es' : '')}`
			};
			fn_setFilters(tabTbl);
			fn_setTabProps(tabTbl, vc);

			tabTbl.fn_tbInfo = () => null;
			return tabTbl;
		})
	};
	
		let tabIx3 = {
		ix: 3,
		lbl: 'By Due Date',
		tblIdKey: '-dueDate',
		filterBtns: fn_ddFilters(),
		fn_fbTitle: (fb) => `Flter Opportunities Due ${(fb.dueAfter ? 'After' : 'by')} "${fb.date}"`,
		fn_qryPrms: (tab) => {
			let fb = tab.filterBtns.filter(x => x.state)[0] || {};
			let tmId = vc.c_tmIdFilter;
			let cu = null;
			if (!tmId) cu = vc.c_cuFilter;
			return {
				ix:3,
				days: fb.days,
				opportunityStatusIds:null,
				dueDate: fb.date,
				dueAfter: fb.dueAfter,
				teamMemberId: tmId,
				currentUser: cu,
				withArchived:vc.d_withArchived,
			};
		},
		fn_tbInfo: () => null,
	};

	tabIx3.fn_fbClick = (fb) => {
		vc.d_tabCurr.filterBtns.forEach(x => x.state = x.id == fb.id ? true : false);
		fn_setTabProps(tabIx3, vc);
		window.localStorage.setItem(window.location.href+'-quickFilter',JSON.stringify(vc.d_tabCurr.qryPrms));
		fn_saveFilters(vc);
	};
	tabIx3.skipLoad=false;		
	fn_setFilters(tabIx3);
	fn_setTabProps(tabIx3, vc);
	
	tabs.push(tabIx2);
	tabs.push(tabIx3);
	return tabs;
}

//Opportunity Status Filter Helpers
function fn_osPrms(tab) {
	let fb = tab.filterBtns || [];
	let osIds = fb.filter(x => x.state).map(x => x.osId);
	//let NAosIds = fb.filter(x => x.osNm !== 'Archived').map(x => x.osId);
	//return osIds.length == 0? JSON.stringify(NAosIds) : JSON.stringify(osIds);
	//return osIds.length == 0 || osIds.length == fb.length ? null : JSON.stringify(osIds);
	return osIds.length == 0 ? null : JSON.stringify(osIds);
}
function fn_osFilterNote(tab, vc) {
	let fb = tab.filterBtns || [];

	console.log('In fn_osFilterNote');
	console.log('tab');
	console.log(tab);
	//let tmfLbl = vc.$parent.c_tmFilterLbl;
	//let note = tmfLbl || 'Opportunities';
	//console.log(`tmfLbl: ${tmfLbl} note: ${note}`);
	let note=tab.lbl=='All'?'All Opportunities':tab.lbl;
	let osNms = fb.filter(x => x.state).map(x => x.osNm);
	let len = osNms.length;
	//let note=tab.lbl=='All'?'All Opportunities':tab.lbl;
	//if (len == 0 || len == fb.length) return (tmfLbl ? '' : 'All ') + note + ' in all Statuses';
	if (len == 0 || len == fb.length) return note + ' in all Statuses';
	else return note + ` in the "${osNms.join('", "')}" Status${(len > 1 ? 'es' : '')}`;
}
function fn_ddFilterNote(tab, vc) {
	let fb = tab.filterBtns.filter(x => x.state)[0] || {};

	let tmfLbl = vc.$parent.c_tmFilterLbl;
	let note = tmfLbl || 'Opportunities';
	return note + ' Due ' + (fb.dueAfter ? 'After ' : 'by ') + util.fn_fmtDt(fb.date);
}
function fn_setTabProps(tab, vc) {
	tab.qryPrms = tab.fn_qryPrms(tab);
	tab.tbNote = tab.ix <= 1 ? fn_osFilterNote(tab, vc) : tab.ix == 3 ? fn_ddFilterNote(tab, vc) : null;
}



//Due Data Filter Helpers
function fn_ddFilters() {

	let addDays = (num) => {
		let dt = new Date();
		dt.setDate(dt.getDate() + num);
		return util.fn_isoDtStr(dt);
	};

	return [
		{
			id: 1,
			days:-1,
			date: addDays(-1),
			label: "Past Due",
			state: false
		},
		{
			id: 2,
			days:7,
			date: addDays(7),
			label: "Due in 7 Days",
			state: true
		},
		{
			id: 3,
			days:30,
			date: addDays(30),
			label: "Due in 30 Days",
			state: false
		},
		{
			id: 4,
			days: 90,
			date: addDays(90),
			label: "Due in 90 Days",
			state: false
		},
		{
			id: 5,
			days: 91,
			date: addDays(91),
			label: "Due After 90 Days",
			state: false,
			dueAfter: true
		}
	];
}

//Opportunity Status Filter By Opportunity Type Helpers


function fn_osByotFilters(ot) {
	let opprStatuses = refData.opportunityStatuses;
	return fn_helper(ot).map(os => {
		return {
			otNm: ot.name,
			osNm: os.name,
			osId: os.id,
			state: false
		};
	});
	

	function fn_helper(ot) {
		switch (ot.name) {
			case "Lead":
				return [];
			case "Tender":
				return opprStatuses.filter(x =>
					/(Open)|(Submitted)|(Not Awarded)/i.test(x.name)
				);
			case "RFP":
			case "RFQ":
			case "Estimate":
				return opprStatuses.filter(x => /(Open)|(Submitted)/i.test(x.name));
			case "Awarded":
				return opprStatuses.filter(x => /(Launching)|(Launched)/i.test(x.name));
		}
	}
}


function fn_byOpprTypeHandler(vc) {
	//Need to reset these when rendering By Oppr Type tab
	vc.d_tabCurr.tabTbls.forEach(x => {
		//x.filterBtns.forEach(x => x.state = null);
		x.qryPrms = x.fn_qryPrms();
		x.tbNote = x.fn_tbNote();
		x.skipLoad = false;  //true
		fn_setFilters(x);
	});
	
   
	let reqPrms = {
		teamMemberId: vc.c_tmIdFilter,
		currentUser: vc.c_cuFilter,
		offset:0,
		limit:vc.d_pageSize
	};

	
	fn_getTableData("opportunitiesGrouped", reqPrms).then(resp => {
		vc.d_tabCurr.tabTbls.forEach(tabTbl => {
			tabTbl.skipLoad = null;
			let tbl = vc.$refs['kt-table' + tabTbl.tblIdKey];
			if (!tbl) return;
			console.log("In opportunitiesGrouped");
			console.log(resp);
			let respOT = resp.error ? resp: resp[tabTbl.otId];			
			//tbl[0].m_loadResp(respOT);
		});
	});

}



function fn_setFilters(tab) {
	let uonf = userSettings.userOptions.opprNavFilters || {};
	uonf = uonf[tab.ix] || [];

	if (tab.ix == 3 && uonf.length) {
		tab.filterBtns.forEach(fb => fb.state = false);
	}
	uonf.forEach(x => {
		let fb = tab.filterBtns.filter(fb => (fb.osId || fb.id) == x)[0];
		if (fb) fb.state = true;
	});
}



function fn_saveFilters(vc) {
	let val = {};
	vc.d_tabs.forEach(t => {
		if(t.ix != 2) val[t.ix] = t.filterBtns.filter(x => x.state&&x.osNm!=='Archived').map(x => x.osId || x.id);
		else t.tabTbls.forEach((tt,i)=>{val[`${t.ix}-${i}`]=tt.filterBtns.filter(x => x.state&&x.osNm!=='Archived').map(x => x.osId || x.id)});
	});
	util.fn_saveUserOpts('opprNavFilters', null, val);
}

function fn_addCustomFields(){
	var customFields=refData.customFields.filter(c=>(c.context=='oppr'));
	var customColumns=[];
	var customColumn;
	//var fn_fmtMoney
	customFields.forEach(cf=>{
				customColumn={
						field: cf.name,
						title: cf.label,
						sortable:true,
						visible:true,
						datatype:cf.multiSelect?"array":cf.type,
						__dbvw: true,
						valFmtFn: cf.type=='money'?val => val?'$'+Number(val).toLocaleString():null:null,
						fn_hrefLink: ['email','tel','url'].includes(cf.type)?(type,value)=> 
						{if(type=='url'&&!value.includes('http')) value='http://'+value;
						return util.fn_hrefLink(type, value);}:null,
						fn_hrefAppLink: ['oppr','proj','acct','extr','cmpt','team'].includes(cf.type)?(type,value)=> {return util.fn_hrefVwRec(type, value);}:null,
						multiSelect:cf.multiSelect,
						listOfValues:cf.listOfValues,
						customField:true,
						};
						
	if(customColumn.multiSelect) customColumn.valFmtFn=(val)=>{return val instanceof Array?val.join():null;};			
	customColumns.push(customColumn);

		});
	return customColumns;
}

</script>

<style lang="less">
.btn-active{color:white;
			background-color:#28a745;
			}
</style>